import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import {DatePicker} from 'react-tempusdominus-bootstrap';
const $ = require('jquery');
const jzip = require('jzip');
import Select from 'react-select';
import {PfButton} from '@profabric/react-components';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'เลขใบงาน',
    data: 'planid'
  },
  {
    title: 'สำนักงาน',
    data: 'site'
  },
  {
    title: 'วันที่คีย์ข้อมูล',
    data: 'date_insert'
  },
  {
    title: 'วันที่เดินทาง',
    data: 'date_start'
  },
  {
    title: 'วันที่เดินทางกลับ',
    data: 'date_stop'
  },
  {
    title: 'ประเภท',
    data: 'typeName'
  },
  {
    title: 'หมายเลข / ทะเบียนรถ',
    data: 'plate_no'
  },
  {
    title: 'คนขับ',
    data: 'driver_name'
  },
  {
    title: 'เจ้าของ',
    data: 'owner_name'
  },
  {
    title: 'จุดประสงค์',
    data: 'objectiveShort'
  },
  {
    title: 'จุดประสงค์เต็ม',
    data: 'objective'
  },
  {
    title: 'รหัสพนักงาน',
    data: 'staffid'
  },
  {
    title: 'ผู้ขอ',
    data: 'staff'
  },
  {
    title: 'แผนก',
    data: 'department'
  },
  {
    title: 'บริษัท',
    data: 'company'
  },
  {
    title: 'cost center',
    data: 'costcenter'
  },
  {
    title: 'ระยะทาง plan',
    data: 'distanceTable'
  },
  {
    title: 'ระยะทาง actual',
    data: 'distanceActualTable'
  },
  {
    title: 'เรท',
    data: 'rate'
  },
  {
    title: 'รหัสรถ',
    data: 'typeName2'
  },
  {
    title: 'ค่าเดินทาง actual',
    data: 'totaCostActualTable'
  },
  {
    title: 'ค่าใช้จ่ายอื่นๆ',
    data: 'totalExpend'
  },
  {
    title: 'สุทธิ',
    data: 'grandTotal'
  },
  {
    title: 'วันที่อนุมัติครบ',
    data: 'date_approve'
  },
  {
    title: 'คะแนนความพอใจ(1->5)',
    data: 'rating'
  },
  {
    title: '',
    data: 'planid',
    render: function (data, type, row) {
      // console.log(row);
      if (type === 'display') {
        if (row.enableShortcut) {
          return `<input class="btn btn-primary btn-xs m-1" type="button" value="อนุมัติ" id="a-${data}"><input class="btn btn-danger btn-xs m-1" type="button" value="ไม่อนุมัติ" id="r-${data}">`;
        } else {
          if (row.status === '')
            return `<input class="btn btn-primary btn-xs m-1" type="button" value="on process" disabled id="cp-${data}">`;
          if (row.status === 'approve')
            return `<input class="btn btn-success btn-xs m-1" type="button" value="complete" disabled id="cp-${data}">`;
          if (row.status === 'reject')
            return `<input class="btn btn-danger btn-xs m-1" type="button" value="rejected" disabled id="rj-${data}">`;
          if (row.status === 'cancell')
            return `<input class="btn btn-warning btn-xs m-1" type="button" value="cancelled" disabled id="cc-${data}">`;
        }
      }
      return data;
    }
  },
  {
    title: 'View',
    data: 'planid',
    render: function (data, type) {
      if (type === 'display') {
        return `<a class="text-muted"><i class="fas fa-search" /></a>`;
      }
      return data;
    }
  }
];

function reloadTableData(items, page, select) {
  console.log('reload: ' + items.length);
  console.log('page: ' + page);
  const table = $(`#${0}`).DataTable();
  //   const table = $(`table.example`).DataTable();
  table.clear();

  if (select !== 'A') {
    items = items.filter((el) => el.typeValue === select);
  }

  table.rows.add(items);
  table.draw();
  table.page(page).draw('page');
}

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month].join('-');
}

function generateOptions() {
  let opt = [{value: 'ALL', label: 'ALL'}];
  for (let i = 0; i < 12; i++) {
    const _d = new Date().setMonth(new Date().getMonth() - i);
    const _e = {
      value: formatDate(_d),
      label: formatDate(_d)
    };
    opt.push(_e);
  }
  return opt;
}

function hideCols(typeValue, table) {
  console.log(typeValue);
  var column;
  if (typeValue === '1') {
    column = table.column(5);
    column.visible(false);
  } else {
    column = table.column(5);
    column.visible(true);
  }
}

class TableCrItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opts: [],
      selected: null,
      date_start: null,
      date_stop: null,
      select: true,
      // selectCb: [
      //   {value: 'A', label: 'แสดงทั้งหมด (all)', select: true},
      //   {value: '1', label: 'เบิกค่าเดินทาง (cdsexp)', select: false},
      //   {value: '2', label: 'รถบริการ (carservice)', select: false},
      //   {value: '3', label: 'ยืมรถ (rent car)', select: false},
      //   {value: '4', label: 'ยืมรถ-คนขับ (rent car-driver)', select: false},
      //   {value: '5', label: 'ยืมรถ-รถบริษัท (company car)', select: false}
      // ]
      selectCb: this.props.dropdowns
    };
  }

  componentDidMount() {
    this.setState({
      opts: generateOptions()
    });

    var table = $(`#${0}`).DataTable({
      data: this.props.items,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      scrollX: true,
      errMode: 'none',
      // responsive: true,
      columnDefs: [
        {target: 5, visible: false},
        {target: 11, visible: false}
      ],
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_report_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_report_excel_${Date.now()}`
        }
      ]
    });
    $.fn.dataTable.ext.errMode = 'none';

    $(`#${0} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      this.props.onToggle(data);
    });

    $(`#${0} tbody`).on('click', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      console.log(event.currentTarget.value);
      console.log(data.planid);
      if (event.currentTarget.value === 'อนุมัติ') {
        this.props.onAgree(data.planid);
      } else {
        this.props.onReject(data.planid);
      }
    });

    table.on('page', (event) => {
      var info = table.page.info();
      this.props.onPageChange(info.page);
    });
  }

  componentWillUnmount() {
    $(`#${0}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.items.length !== this.props.items.length) {
      this.setState({
        selectCb: nextProps.dropdowns
      });

      reloadTableData(
        nextProps.items,
        nextProps.page,
        this.state.selectCb.length !== 0
          ? this.state.selectCb.find((e) => e.select === true).value
          : 'A'
      );
    }
    return true;
  }

  // filterTableData(filter) {
  //   const table = $(`#${0}`).DataTable();
  //   //   const table = $(`table.example`).DataTable();
  //   console.log(this.props.items.length);
  //   // table.clear();
  //   // table.rows.add(this.props.items);
  //   // table.draw();
  //   // table.page(page).draw('page');
  // }

  render() {
    return (
      <div>
        <Card className="card">
          {/* <div className={this.props.loading ? 'overlay dark' : 'd-none'}>
            <ClockLoader color="#c4c4c4" />
          </div> */}
          <div className={this.props.show ? 'd-none' : 'overlay dark'}>
            <span style={{color: 'white', fontSize: 30}}>CR ONLY</span>
          </div>
          <Card.Header>
            <div className="row">
              <div className="col-2 mt-1">อนุมัติครบแล้ว</div>
              <div className="col-2 text-right">
                <DatePicker
                  date={this.state.date_start}
                  format="YYYY-MM-DD"
                  onChange={(e) => {
                    this.setState({
                      date_start: e.date
                    });

                    // const table = $(`#${0}`).DataTable();
                    // table.clear();
                    // let temp = this.props.items;
                    // let temp = this.props.items
                    //   .filter(
                    //     (el) =>
                    //       el.date_approve.slice(0, 10) >=
                    //       e.date.format('YYYY-MM-DD')
                    //   )
                    //   .filter(
                    //     (el) =>
                    //       this.state.date_stop === null ||
                    //       el.date_approve.slice(0, 10) <=
                    //         this.state.date_stop.format('YYYY-MM-DD')
                    //   );
                    // if (this.state.select === true) {
                    //   temp = temp.filter((el) => el.typeValue === '1');
                    // } else {
                    //   temp = temp.filter((el) => el.typeValue === '2');
                    // }

                    // if (this.state.selectCb !== 'A') {
                    //   temp = temp.filter((el) => el.typeValue === this.state.selectCb);
                    // }
                    // table.rows.add(temp);
                    // table.draw();
                  }}
                />
              </div>
              <div className="col-2 text-right">
                <DatePicker
                  date={this.state.date_stop}
                  format="YYYY-MM-DD"
                  onChange={(e) => {
                    this.setState({
                      date_stop: e.date
                    });
                    // const table = $(`#${0}`).DataTable();
                    // table.clear();
                    // let temp = this.props.items;
                    // let temp = this.props.items
                    //   .filter(
                    //     (el) =>
                    //       el.date_approve.slice(0, 10) <=
                    //       e.date.format('YYYY-MM-DD')
                    //   )
                    //   .filter(
                    //     (el) =>
                    //       this.state.date_start === null ||
                    //       el.date_approve.slice(0, 10) >=
                    //         this.state.date_start.format('YYYY-MM-DD')
                    //   );
                    // if (this.state.select === true) {
                    //   temp = temp.filter((el) => el.typeValue === '1');
                    // } else {
                    //   temp = temp.filter((el) => el.typeValue === '2');
                    // }

                    // if (this.state.selectCb !== 'A') {
                    //   temp = temp.filter((el) => el.typeValue === this.state.selectCb);
                    // }
                    // table.rows.add(temp);
                    // table.draw();
                  }}
                />
              </div>
              <div className="col-2 text-left">
                {/* <Button
                  className="btn"
                  // variant="outline-primary"
                  onClick={() => {
                    let start = this.state.date_start
                      ? `start=${this.state.date_start.format('YYYY-MM-DD')}`
                      : '';

                    let end = this.state.date_stop
                      ? `end=${this.state.date_stop.format('YYYY-MM-DD')}`
                      : '';
                    this.props.onSubmit(
                      null,
                      this.state.date_start
                        ? `${start}&${end}`
                        : ''
                    );
                  }}
                  // onSubmit
                >
                  ดึงข้อมูล
                </Button> */}
                <PfButton
                  theme="primary"
                  block
                  // type="submit"
                  loading={this.props.loading ? this.props.loading : false}
                  onClick={() => {
                    let start = this.state.date_start
                      ? `start=${this.state.date_start.format('YYYY-MM-DD')}`
                      : '';

                    let end = this.state.date_stop
                      ? `end=${this.state.date_stop.format('YYYY-MM-DD')}`
                      : '';
                    this.props.onSubmit(
                      null,
                      this.state.date_start ? `${start}&${end}` : ''
                    );
                  }}
                >
                  ดึงข้อมูล
                </PfButton>
              </div>
              <div className="col-4 text-right">
                <Select
                  value={this.state.selectCb.find((e) => e.select === true)}
                  options={this.state.selectCb}
                  onChange={(v) => {
                    let _temp = this.state.selectCb.map((e) => ({
                      ...e,
                      select: v.value === e.value
                    }));
                    this.setState({
                      selectCb: _temp
                    });
                    const table = $(`#${0}`).DataTable();
                    table.clear();
                    let temp = this.props.items
                      .filter(
                        (el) =>
                          this.state.date_start === null ||
                          el.date_approve.slice(0, 10) >=
                            this.state.date_start.format('YYYY-MM-DD')
                      )
                      .filter(
                        (el) =>
                          this.state.date_stop === null ||
                          el.date_approve.slice(0, 10) <=
                            this.state.date_stop.format('YYYY-MM-DD')
                      );

                    if (v.value !== 'A') {
                      temp = temp.filter((el) => el.typeValue === v.value);
                    }

                    hideCols(v.value, table);

                    table.rows.add(temp);
                    table.draw();
                  }}
                />
                {/* <BootstrapSwitchButton
                  width={160}
                  checked={this.state.select}
                  onlabel="เบิกค่าเดินทาง"
                  offlabel="รถบริการ"
                  offstyle="success"
                  onChange={(checked) => {
                    this.setState({
                      select: checked
                    });
                    const table = $(`#${0}`).DataTable();
                    table.clear();
                    let temp = this.props.items
                      .filter(
                        (el) =>
                          this.state.date_start === null ||
                          el.date_approve.slice(0, 10) >=
                            this.state.date_start.format('YYYY-MM-DD')
                      )
                      .filter(
                        (el) =>
                          this.state.date_stop === null ||
                          el.date_approve.slice(0, 10) <=
                            this.state.date_stop.format('YYYY-MM-DD')
                      );
                    if (checked === true) {
                      temp = temp.filter((el) => el.typeValue === '1');
                    } else {
                      temp = temp.filter((el) => el.typeValue === '2');
                    }

                    hideCols(checked, table);

                    table.rows.add(temp);
                    table.draw();
                  }}
                /> */}
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <table
              ref="main"
              className="display nowrap example"
              id={0}
              style={{width: '100%'}}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}
export default TableCrItem;
